// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__bHC9U","legacyBtn":"MutateMid_legacyBtn__3w1lW"};